import { Component, Inject, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { SpinnerService } from 'src/app/core/services/spinner.service';
import { ToasterService } from 'src/app/core/services/toastr.service';
import { customerService } from 'src/app/core/services/customer.service';
import { customerData } from 'src/app/models/customerData';

@Component({
  selector: 'megastore-admin-user-topup',
  templateUrl: './user-topup.component.html',
  styleUrls: ['./user-topup.component.scss']
})
export class UserTopupComponent implements OnDestroy {
  userTopupForm: FormGroup;
  submitted = false;
  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { customerData: customerData },
    private dialog: MatDialogRef<UserTopupComponent>,
    private formBuilder: FormBuilder,
    private _toasterService: ToasterService,
    private _customerService: customerService,
    private _spinnerService: SpinnerService,
    private _translateService: TranslateService
  ) {
    this.userTopupForm = this.formBuilder.group({
      amount: ['', [Validators.required, Validators.min(0)]],
    });

    if (this.data.customerData) {
      this.initializeForm();
    }
  }

  initializeForm(): void {
    this.userTopupForm.patchValue({
      amount: this.data.customerData.wallet || ''
    });
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.userTopupForm.valid) {
      this.onFormValid();
    }
  }

  onFormValid(): void {
    const formData = this.userTopupForm.value;
    const updateData: any = {
      userId: this.data.customerData._id,
      amount: Number(formData.amount)
    };

    this._spinnerService.addToLoader('userTopup');
    this._customerService
      .userTopup(updateData)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: customerData) => {
          this._spinnerService.removeFromLoader('userTopup');
          this._toasterService.successToastr(
            this._translateService.instant('UserTopupSuccessfully')
          );
          this.dialog.close(res);
        },
        error: () => {
          this._spinnerService.removeFromLoader('userTopup');
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.complete();
    this.destroy$.unsubscribe();
  }
} 